export default function textareaCount() {

    function textareaSymbolCount() {
        let $this = $(this),
            maxlength = $this.attr('maxlength'),
            currentLength = $this.val().length;


        $this.parents('.textarea-wrap').find('.textarea-counter__current').text(currentLength);
        $this.parents('.textarea-wrap').find('.textarea-counter__max').text(maxlength);

        if( currentLength < maxlength ) {
            $this.parents('.textarea-line').addClass('textarea-line--valid');
        }

        if( currentLength > maxlength ){
            $this.parents('.textarea-line').addClass('textarea-line--invalid');
        }
    }

    $('.textarea').niceScroll({
        cursorcolor:"#7F7F7F",
        cursorwidth:"7px",
        background:"none",
        cursorborder:"none",
        cursorborderradius: 3.5,
        cursoropacitymin: 1,
    });

    $('.textarea').getNiceScroll().resize();

    $('.textarea').on('input', textareaSymbolCount);




}